import React from 'react';
import classNames from 'classnames';
import { ReactComponent as InformationIcon } from 'icons/Information.icon.svg';
import Card from 'components/Card';
import { useTotalCardContent } from '../../hooks/useTotalCardContent';
import { useTranslation } from 'react-i18next';
import { School } from 'models/School';
import { SchoolGroupStructureType } from 'searchality-data';

import './TotalPricePreview.styles.scss';

type TotalPricePreviewProps = {
  className?: string;
  schools: School[];
  structureType: SchoolGroupStructureType;
  hasOldPricingSystem: boolean;
};

const TotalPricePreview: React.FC<TotalPricePreviewProps> = (props) => {
  const { className, structureType, schools, hasOldPricingSystem } = props;

  const { t } = useTranslation();

  const classes = classNames('total-price-preview', className);

  const totalCardContent = useTotalCardContent(
    structureType,
    schools,
    hasOldPricingSystem,
  );

  return (
    <Card
      title={t('Pricing.Total.title')}
      subtitle={totalCardContent.subtitle}
      className={classes}
    >
      {totalCardContent.content}
      <p className="card__hint">
        <InformationIcon />
        {t('Pricing.Total.description')}
      </p>
    </Card>
  );
};

export default TotalPricePreview;
